import { render } from "./CameraCapture.vue?vue&type=template&id=af0b17a4&scoped=true"
import script from "./CameraCapture.vue?vue&type=script&lang=js"
export * from "./CameraCapture.vue?vue&type=script&lang=js"

import "./CameraCapture.vue?vue&type=style&index=0&id=af0b17a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af0b17a4"]])

export default __exports__